// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/db_migration_service.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * AdminDropColumnArgs メッセージ
 *
 * @generated from message service.AdminDropColumnArgs
 */
export class AdminDropColumnArgs extends Message<AdminDropColumnArgs> {
  /**
   * @generated from field: string entity_name = 1 [json_name = "entity_name"];
   */
  entityName = "";

  /**
   * @generated from field: string column_name = 2 [json_name = "column_name"];
   */
  columnName = "";

  constructor(data?: PartialMessage<AdminDropColumnArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminDropColumnArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entity_name", jsonName: "entity_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "column_name", jsonName: "column_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminDropColumnArgs {
    return new AdminDropColumnArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminDropColumnArgs {
    return new AdminDropColumnArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminDropColumnArgs {
    return new AdminDropColumnArgs().fromJsonString(jsonString, options);
  }

  static equals(a: AdminDropColumnArgs | PlainMessage<AdminDropColumnArgs> | undefined, b: AdminDropColumnArgs | PlainMessage<AdminDropColumnArgs> | undefined): boolean {
    return proto3.util.equals(AdminDropColumnArgs, a, b);
  }
}

/**
 * AdminAddIndexArgs メッセージ
 *
 * @generated from message service.AdminAddIndexArgs
 */
export class AdminAddIndexArgs extends Message<AdminAddIndexArgs> {
  /**
   * @generated from field: string entity_name = 1 [json_name = "entity_name"];
   */
  entityName = "";

  /**
   * @generated from field: string column_name = 2 [json_name = "column_name"];
   */
  columnName = "";

  constructor(data?: PartialMessage<AdminAddIndexArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminAddIndexArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entity_name", jsonName: "entity_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "column_name", jsonName: "column_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminAddIndexArgs {
    return new AdminAddIndexArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminAddIndexArgs {
    return new AdminAddIndexArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminAddIndexArgs {
    return new AdminAddIndexArgs().fromJsonString(jsonString, options);
  }

  static equals(a: AdminAddIndexArgs | PlainMessage<AdminAddIndexArgs> | undefined, b: AdminAddIndexArgs | PlainMessage<AdminAddIndexArgs> | undefined): boolean {
    return proto3.util.equals(AdminAddIndexArgs, a, b);
  }
}

/**
 * AdminDropIndexArgs メッセージ
 *
 * @generated from message service.AdminDropIndexArgs
 */
export class AdminDropIndexArgs extends Message<AdminDropIndexArgs> {
  /**
   * @generated from field: string entity_name = 1 [json_name = "entity_name"];
   */
  entityName = "";

  /**
   * @generated from field: string column_name = 2 [json_name = "column_name"];
   */
  columnName = "";

  constructor(data?: PartialMessage<AdminDropIndexArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminDropIndexArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entity_name", jsonName: "entity_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "column_name", jsonName: "column_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminDropIndexArgs {
    return new AdminDropIndexArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminDropIndexArgs {
    return new AdminDropIndexArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminDropIndexArgs {
    return new AdminDropIndexArgs().fromJsonString(jsonString, options);
  }

  static equals(a: AdminDropIndexArgs | PlainMessage<AdminDropIndexArgs> | undefined, b: AdminDropIndexArgs | PlainMessage<AdminDropIndexArgs> | undefined): boolean {
    return proto3.util.equals(AdminDropIndexArgs, a, b);
  }
}

/**
 * AdminAddCompositeIndexArgs メッセージ
 *
 * @generated from message service.AdminAddCompositeIndexArgs
 */
export class AdminAddCompositeIndexArgs extends Message<AdminAddCompositeIndexArgs> {
  /**
   * @generated from field: string entity_name = 1 [json_name = "entity_name"];
   */
  entityName = "";

  /**
   * @generated from field: repeated string column_names = 2 [json_name = "column_names"];
   */
  columnNames: string[] = [];

  /**
   * @generated from field: string index_name = 3 [json_name = "index_name"];
   */
  indexName = "";

  constructor(data?: PartialMessage<AdminAddCompositeIndexArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminAddCompositeIndexArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entity_name", jsonName: "entity_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "column_names", jsonName: "column_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "index_name", jsonName: "index_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminAddCompositeIndexArgs {
    return new AdminAddCompositeIndexArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminAddCompositeIndexArgs {
    return new AdminAddCompositeIndexArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminAddCompositeIndexArgs {
    return new AdminAddCompositeIndexArgs().fromJsonString(jsonString, options);
  }

  static equals(a: AdminAddCompositeIndexArgs | PlainMessage<AdminAddCompositeIndexArgs> | undefined, b: AdminAddCompositeIndexArgs | PlainMessage<AdminAddCompositeIndexArgs> | undefined): boolean {
    return proto3.util.equals(AdminAddCompositeIndexArgs, a, b);
  }
}

/**
 * AdminDropCompositeIndexArgs メッセージ
 *
 * @generated from message service.AdminDropCompositeIndexArgs
 */
export class AdminDropCompositeIndexArgs extends Message<AdminDropCompositeIndexArgs> {
  /**
   * @generated from field: string entity_name = 1 [json_name = "entity_name"];
   */
  entityName = "";

  /**
   * @generated from field: repeated string column_names = 2 [json_name = "column_names"];
   */
  columnNames: string[] = [];

  /**
   * @generated from field: string index_name = 3 [json_name = "index_name"];
   */
  indexName = "";

  constructor(data?: PartialMessage<AdminDropCompositeIndexArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminDropCompositeIndexArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entity_name", jsonName: "entity_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "column_names", jsonName: "column_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "index_name", jsonName: "index_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminDropCompositeIndexArgs {
    return new AdminDropCompositeIndexArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminDropCompositeIndexArgs {
    return new AdminDropCompositeIndexArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminDropCompositeIndexArgs {
    return new AdminDropCompositeIndexArgs().fromJsonString(jsonString, options);
  }

  static equals(a: AdminDropCompositeIndexArgs | PlainMessage<AdminDropCompositeIndexArgs> | undefined, b: AdminDropCompositeIndexArgs | PlainMessage<AdminDropCompositeIndexArgs> | undefined): boolean {
    return proto3.util.equals(AdminDropCompositeIndexArgs, a, b);
  }
}

/**
 * AdminDropColumnReply メッセージ
 *
 * @generated from message service.AdminDropColumnReply
 */
export class AdminDropColumnReply extends Message<AdminDropColumnReply> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * @generated from field: string table_name = 3 [json_name = "table_name"];
   */
  tableName = "";

  constructor(data?: PartialMessage<AdminDropColumnReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminDropColumnReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "table_name", jsonName: "table_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminDropColumnReply {
    return new AdminDropColumnReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminDropColumnReply {
    return new AdminDropColumnReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminDropColumnReply {
    return new AdminDropColumnReply().fromJsonString(jsonString, options);
  }

  static equals(a: AdminDropColumnReply | PlainMessage<AdminDropColumnReply> | undefined, b: AdminDropColumnReply | PlainMessage<AdminDropColumnReply> | undefined): boolean {
    return proto3.util.equals(AdminDropColumnReply, a, b);
  }
}

/**
 * AdminAddIndexReply メッセージ
 *
 * @generated from message service.AdminAddIndexReply
 */
export class AdminAddIndexReply extends Message<AdminAddIndexReply> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * @generated from field: string index_name = 3 [json_name = "index_name"];
   */
  indexName = "";

  /**
   * @generated from field: string table_name = 4 [json_name = "table_name"];
   */
  tableName = "";

  constructor(data?: PartialMessage<AdminAddIndexReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminAddIndexReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "index_name", jsonName: "index_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "table_name", jsonName: "table_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminAddIndexReply {
    return new AdminAddIndexReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminAddIndexReply {
    return new AdminAddIndexReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminAddIndexReply {
    return new AdminAddIndexReply().fromJsonString(jsonString, options);
  }

  static equals(a: AdminAddIndexReply | PlainMessage<AdminAddIndexReply> | undefined, b: AdminAddIndexReply | PlainMessage<AdminAddIndexReply> | undefined): boolean {
    return proto3.util.equals(AdminAddIndexReply, a, b);
  }
}

/**
 * AdminDropIndexReply メッセージ
 *
 * @generated from message service.AdminDropIndexReply
 */
export class AdminDropIndexReply extends Message<AdminDropIndexReply> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * @generated from field: string index_name = 3 [json_name = "index_name"];
   */
  indexName = "";

  constructor(data?: PartialMessage<AdminDropIndexReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminDropIndexReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "index_name", jsonName: "index_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminDropIndexReply {
    return new AdminDropIndexReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminDropIndexReply {
    return new AdminDropIndexReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminDropIndexReply {
    return new AdminDropIndexReply().fromJsonString(jsonString, options);
  }

  static equals(a: AdminDropIndexReply | PlainMessage<AdminDropIndexReply> | undefined, b: AdminDropIndexReply | PlainMessage<AdminDropIndexReply> | undefined): boolean {
    return proto3.util.equals(AdminDropIndexReply, a, b);
  }
}

/**
 * AdminAddCompositeIndexReply メッセージ
 *
 * @generated from message service.AdminAddCompositeIndexReply
 */
export class AdminAddCompositeIndexReply extends Message<AdminAddCompositeIndexReply> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * @generated from field: string index_name = 3 [json_name = "index_name"];
   */
  indexName = "";

  /**
   * @generated from field: string table_name = 4 [json_name = "table_name"];
   */
  tableName = "";

  constructor(data?: PartialMessage<AdminAddCompositeIndexReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminAddCompositeIndexReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "index_name", jsonName: "index_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "table_name", jsonName: "table_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminAddCompositeIndexReply {
    return new AdminAddCompositeIndexReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminAddCompositeIndexReply {
    return new AdminAddCompositeIndexReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminAddCompositeIndexReply {
    return new AdminAddCompositeIndexReply().fromJsonString(jsonString, options);
  }

  static equals(a: AdminAddCompositeIndexReply | PlainMessage<AdminAddCompositeIndexReply> | undefined, b: AdminAddCompositeIndexReply | PlainMessage<AdminAddCompositeIndexReply> | undefined): boolean {
    return proto3.util.equals(AdminAddCompositeIndexReply, a, b);
  }
}

/**
 * AdminDropCompositeIndexReply メッセージ
 *
 * @generated from message service.AdminDropCompositeIndexReply
 */
export class AdminDropCompositeIndexReply extends Message<AdminDropCompositeIndexReply> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * @generated from field: string index_name = 3 [json_name = "index_name"];
   */
  indexName = "";

  constructor(data?: PartialMessage<AdminDropCompositeIndexReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.AdminDropCompositeIndexReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "index_name", jsonName: "index_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminDropCompositeIndexReply {
    return new AdminDropCompositeIndexReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminDropCompositeIndexReply {
    return new AdminDropCompositeIndexReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminDropCompositeIndexReply {
    return new AdminDropCompositeIndexReply().fromJsonString(jsonString, options);
  }

  static equals(a: AdminDropCompositeIndexReply | PlainMessage<AdminDropCompositeIndexReply> | undefined, b: AdminDropCompositeIndexReply | PlainMessage<AdminDropCompositeIndexReply> | undefined): boolean {
    return proto3.util.equals(AdminDropCompositeIndexReply, a, b);
  }
}

